import React, { Component } from 'react';
import { Form, Input, Row, Col, Tooltip, Icon, Alert, message } from "antd";

const FormItem = Form.Item;
const Close = <Icon type="minus-circle" style={{ color: '#FF5B5B ', verticalAlign: 'middle', marginTop: 13, marginLeft: 16 }} />;
import cloneDeep from 'lodash/cloneDeep';
class CustomColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: (props.initialValue != null ? cloneDeep(props.initialValue) : [{ key: undefined, name: undefined }])
    }
  }

  componentDidMount() {
    const {props} = this;
    this.props.onRef(this);
    this.setState({
      rows: (props.initialValue != null ? cloneDeep(props.initialValue) : [{ key: undefined, name: undefined }])
    })
  }

  handleSubmit = (cb) => {
    const { form: { validateFields }, flag } = this.props;
    if(!flag) {
      cb&&cb(null);
      return;
    }
    validateFields((err, values) => {
      if (!err) {
        const keys = Object.keys(values).filter(item => item.indexOf('key') > -1)
        const target = keys.map(key => ({
          key: values[key],
          name: values[key.replace('key', 'name')]
        }))
        cb && cb(JSON.stringify(target))
      }
    })
  }
  getFiledValues() {
    const {getFieldsValue} = this.props.form;
    const values =  getFieldsValue()
    const keys = Object.keys(values).filter(item => item.indexOf('key') > -1)
    const target = keys.map(key => ({
      key: values[key],
      name: values[key.replace('key', 'name')]
    }))
    return target;
  }
  renderCol = (key, val, i, message) => {
    const {
      form: {
        getFieldDecorator
      },
    } = this.props;
    return (

      <FormItem style={{ marginBottom: 0 }}>
        {
          getFieldDecorator(`${key+i}`, {
            initialValue: val,
            rules: [
              {
                required: true,
                whitespace: true,
                message: message,
              },
            ],
          })(
            <Input style={{ width: 'calc(100% - 8px)' }} placeholder={message} />
          )
        }
      </FormItem>
    )
  }
  deleteHandle = (item, i) => {
    const {setFieldsValue} = this.props.form;
      const rows = this.getFiledValues();
      rows.splice(i, 1);
      this.setState({rows: rows}, () => {
        let data = {}
        for(var k = 0; k < rows.length; k++) {
          data[`name${k}`] = rows[k].name
          data[`key${k}`] = rows[k].key
        }
        setFieldsValue({...data})
      })
  }
  
  renderRow = (item, i) => (
    <Row>
      <Col span={11}>
        {this.renderCol('name', item.name, i, "请输入业务列名称")}
      </Col>
      <Col span={11}>
        {this.renderCol('key', item.key, i, "请输入字段名称")}
      </Col>
      {
        i == 0 ? null : <Col span={1} onClick={this.deleteHandle.bind(this, item, i)}>{Close}</Col>
      }
    </Row>
  )

  render() {
    const {
      flag,
    } = this.props;
    return <>
      <Row>
        <Col span={5}>
          <div style={{ textAlign: 'right', lineHeight: '40px' }}>自定义业务列：</div>
        </Col>
        <Col span={1}>
          {this.props.children}
        </Col>
        <Col span={2}>
          <Tooltip placement="rightTop" overlayClassName="sessionFlowSettingTooltip" title={'请输入列名，例如：姓名，会将该列展示在任务详情中作为新的一列展示；请输入字段名，例如：name，会自动读取通过excel表格或者接口传过来的业务字段'}>
            <Icon type="info-circle" style={{ marginLeft: '27px', marginTop: '14px', color: '#969799' }} />
          </Tooltip>
        </Col>
      </Row>
      {
        flag ?
          <Row>
            <Col span={5}></Col>
            <Col span={19}>
              {/* {
                Form.create()(
                  <div className='fieldFilterOptions'>
                    {this.state.rows.map((item, i) => {
                      return this.renderRow(item, i)
                    })}
                  </div>
                )
              } */}
              <Form>
                <div className='fieldFilterOptions'>
                  {this.state.rows.map((item, i) => {
                    return this.renderRow(item, i)
                  })}
                </div>
              </Form>
              <div className="fieldFilterBtn">
                <div onClick={() => {
                  this.setState(({ rows }) => {
                    rows.push({ key: undefined, name: undefined });
                    if (rows.length > 10) {
                      message.error('最多支持10个自定义列展示');
                      return;
                    }
                    return {
                      rows
                    }
                  })
                }}>
                  <Icon type="plus-circle" />
                  &nbsp;
                  <span>增加业务列</span>
                </div>
              </div>
            </Col>
          </Row>
          : null
      }
    </>
  }
}

export default Form.create()(CustomColumn);
// export default CustomColumn;